import type { CompoundEntityRef } from '@backstage/catalog-model';

import { parseEntityRef } from '@backstage/catalog-model';

type NullableCompoundEntityRef<T> = T extends null | undefined
  ? null
  : CompoundEntityRef;

export const createCompoundEntityRef = <
  T extends CompoundEntityRef | null | string | undefined,
>(
  entityRef: T,
  fallbackKind?: string,
): NullableCompoundEntityRef<T> => {
  if (entityRef === null || entityRef === undefined) {
    return null as NullableCompoundEntityRef<T>;
  }
  return (
    typeof entityRef === 'string'
      ? parseEntityRef(entityRef, { defaultKind: fallbackKind })
      : entityRef
  ) as NullableCompoundEntityRef<T>;
};
